export const PRODUCT_NAME = {
    casinogo: 'casinogo',
    casino: 'casino',
}
